import styled from "styled-components";

import { IconButton } from "@similarweb/ui-components";

import { RowSelectionConsumer } from "app/components/React/Table/cells/RowSelection";
import { SelectAllRowsHeaderCellConsumer } from "app/components/React/Table/headerCells/SelectAllRowsHeaderCell";
import { i18nFilter } from "app/filters/i18nFilter";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import {
    ChangePercentage,
    IndexCell,
    RankCell,
    ReferringCategoryCell,
    TrafficShare,
    WebsiteTooltipTopCell,
} from "../../../../components/React/Table/cells";
import { DefaultCellHeader, HeaderCellBlank } from "../../../../components/React/Table/headerCells";
import { DEFAULT_SORT_DIRECTION, DEFAULT_SORT_FIELD } from "../incomingTrafficConsts";

const NewChangeWrapper = styled(FlexRow)`
    justify-content: flex-end;
`;

const i18n = i18nFilter();
export const IncomingTrafficSingleTableSettings = {
    defaultSortField: DEFAULT_SORT_FIELD,
    defaultSortDirection: DEFAULT_SORT_DIRECTION,
    searchFieldName: "domain",
    getColumns: (
        sortedColumn = { field: DEFAULT_SORT_FIELD, sortDirection: DEFAULT_SORT_DIRECTION },
        isDaily = false,
        useSelection,
        durationTooltipParams,
        _webSource?,
        _showEngagementScore?,
        _handleOpenQualificationSideBar = undefined,
        _isUSState?,
    ) => {
        const columns: any = [
            {
                fixed: true,
                cellComponent: ({ row }) => {
                    return (
                        <>
                            {!row.parent ? (
                                <IconButton
                                    iconName="chev-right"
                                    type="flat"
                                    className="enrich"
                                />
                            ) : null}
                        </>
                    );
                },
                sortable: false,
                headerComponent: HeaderCellBlank,
                isResizable: false,
                width: 40,
                columnClass: "collapseControlColumn", // optional
                cellClass: "collapseControlCell", // optional
                disableHeaderCellHover: true,
            },
            {
                fixed: true,
                cellComponent: RowSelectionConsumer,
                sortable: false,
                headerComponent: SelectAllRowsHeaderCellConsumer,
                isResizable: false,
                width: 40,
                visible: useSelection,
            },
            {
                fixed: true,
                cellComponent: IndexCell,
                headerComponent: HeaderCellBlank,
                disableHeaderCellHover: true,
                sortable: false,
                isResizable: false,
                width: 40,
            },
            {
                minWidth: 244,
                isResizable: true,
                sortable: true,
                field: "Domain",
                showTotalCount: true,
                displayName: i18n("analysis.source.referrals.table.columns.domain.title"),
                tooltip: i18n("analysis.source.referrals.table.columns.domain.title.tooltip"),

                cellComponent: WebsiteTooltipTopCell,
            },
            {
                minWidth: 280,
                isResizable: true,
                sortable: true,
                field: "Category",
                displayName: i18n("analysis.source.referrals.table.columns.category.title"),
                tooltip: i18n("analysis.source.referrals.table.columns.category.title.tooltip"),
                cellComponent: ReferringCategoryCell,
            },
            {
                minWidth: 104,
                isResizable: true,
                sortable: true,
                field: "Rank",
                displayName: i18n("analysis.source.referrals.table.columns.rank.title"),
                tooltip: i18n("analysis.source.referrals.table.columns.rank.title.tooltip"),
                cellComponent: RankCell,
            },
            {
                minWidth: 138,
                isResizable: true,
                sortable: true,
                field: "Share",
                displayName: i18n("analysis.source.referrals.table.columns.share.title"),
                tooltip: i18n("analysis.source.referrals.table.columns.share.title.tooltip"),
                cellComponent: TrafficShare,
            },
            {
                minWidth: 108,
                isResizable: true,
                sortable: true,
                field: "Change",
                displayName: i18n("analysis.source.search.all.table.columns.change.title"),
                tooltip: i18n("analysis.source.search.all.table.columns.change.title.tooltip", durationTooltipParams),
                cellComponent: (props) =>
                    props.row.NewChange ? (
                        <NewChangeWrapper>{i18n("new.label.pill")}</NewChangeWrapper>
                    ) : (
                        <ChangePercentage {...props} />
                    ),
                visible: !isDaily,
            },
        ];
        return columns.map((col: any) => {
            const isSorted = sortedColumn && col.field === sortedColumn.field;
            return {
                ...col,
                visible: col.visible !== false,
                headerComponent: col.headerComponent || DefaultCellHeader,
                isSorted,
                sortDirection: isSorted ? sortedColumn.sortDirection : DEFAULT_SORT_DIRECTION,
            };
        });
    },
};
